import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";
import { CardPattern } from "../../utils/types";
import { createPattern } from "../../utils/PatternGenerator";
import { DoneOutline } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  container: {
    width: 120,
  },
  iconContainer: {
    display: "none",

    "&.voted": {
      display: "block",
      padding: "1em",
      background: "white",
      borderRadius: "50%",
    },
  },
  icon: {
    display: "block",
    fontSize: "3.75rem",
  },
  result: {
    fontSize: "3.75rem",
    marginTop: "0.15em",
  },
  vote: {
    height: 150,
    width: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "0.25em",
    backgroundColor: "#fbfaef",
  },
  user: {
    wordBreak: "break-word",
  },
}));

type VoteProps = {
  show: boolean;
  username: string;
  pattern: CardPattern;
  vote?: string;
};

export const Vote: React.FC<VoteProps> = ({
  show,
  username,
  vote,
  pattern,
}) => {
  const classes = useStyles();
  const voted = Boolean(vote);

  return (
    <Box className={classes.container} textAlign="center">
      <Paper
        variant="outlined"
        elevation={1}
        className={classnames(classes.vote, { voted: voted && !show })}
        style={!show ? createPattern(pattern) : {}}
      >
        {voted && show && (
          <Typography component="p" className={classes.result}>
            {vote}
          </Typography>
        )}
        <div
          className={classnames(classes.iconContainer, {
            voted: voted && !show,
          })}
        >
          {voted && !show && <DoneOutline className={classes.icon} />}
        </div>
      </Paper>
      <Typography className={classes.user}>{username}</Typography>
    </Box>
  );
};
